/*
 * File: /src/services/queueService.js
 * Created Date: Sunday May 23rd 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 23rd May 2021 11:03:48 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */
import { authedAxios } from '../shared/axiosWrapper';
import { AD_BASE_QUEUE_PATH } from '../constants';

export default {
  /**
   * Fetch All Queues
   */
  fetchQueues(params = {}) {
    return authedAxios.get(AD_BASE_QUEUE_PATH, { params: params });
  },

  fetchQueue(id) {
    return authedAxios.get(AD_BASE_QUEUE_PATH + id);
  },

  updateQueue(id, payload) {
    return authedAxios.put(AD_BASE_QUEUE_PATH + id, payload);
  },

  createQueue(payload) {
    return authedAxios.post(AD_BASE_QUEUE_PATH, payload);
  },

  deleteQueue(id) {
    return authedAxios.delete(AD_BASE_QUEUE_PATH + id);
  },
};
